import { render, staticRenderFns } from "./VerifyEmailBannerDataProvider.vue?vue&type=template&id=26e4b40a"
import script from "./VerifyEmailBannerDataProvider.vue?vue&type=script&lang=ts"
export * from "./VerifyEmailBannerDataProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports